"use client";

export function OnboardingLayout({ children }: { children: React.ReactNode }) {
	return (
		<div className="min-h-screen w-full overflow-y-auto relative">
			<div className="min-h-screen flex items-center justify-center">
				<div className="fixed left-[-30vh] top-[-30vh] w-[100vh] h-[100vh] rounded-full opacity-20 bg-surface-highlight-soprano blur-[70px] pointer-events-none" />
				<div className="fixed right-[-30vh] bottom-[-30vh] w-[100vh] h-[100vh] rounded-full opacity-20 bg-surface-highlight blur-[120px] pointer-events-none" />
				{children}
			</div>
		</div>
	);
}
